<template>
  <div class="sidebar-container">
    <!-- Sidebar toggle at the top -->
    <a role="button"
       v-if="!hideToggle"
       class="toggle-top"
       @click="toggleSidebar()"/>
    <!-- /Sidebar toggle at the top -->

    <!-- Sidebar -->
    <b-sidebar :no-slide="fixSidebar"
               :class="setSidebarClass()"
               :width="sidebarWidth"
               :no-header-close="fixSidebar"
               :backdrop="!fixSidebar"
               backdrop-variant="white"
               v-model="showSidebar">

      <!-- Sidebar header -->
      <template #header>
        <!-- EY logo -->
        <div class="ey-logo" @click="pushRoute('/esg')">
          <img class="ey-logo-img"
               src="../../../assets/logo_ey2.png"
               alt="EY Logo"/>
          <span class="ey-logo-text">ESG Portal</span>
        </div>
        <!-- EY logo -->

        <!-- Sidebar toggle -->
        <a role="button"
           v-if="!hideToggle"
           class="toggle-side"
           @click="toggleSidebar()"/>
        <!-- /Sidebar toggle -->
      </template>
      <!-- /Sidebar header -->

      <!-- Sidebar body -->
      <sidebar-menu :menu="menu"
                    theme="black-theme"
                    width="auto"
                    :showOneChild="true"
                    :hide-toggle="true"/>
      <!-- /Sidebar body -->

    </b-sidebar>
    <!-- /Sidebar -->
  </div>
</template>

<script>
export default {
  mounted() {
    this.setHideToggle()
    window.addEventListener('resize', this.setHideToggle)
  },
  destroyed() {
    window.removeEventListener('resize', this.setHideToggle)
  },
  methods: {
    setSidebarClass() {
      let visible = this.fixSidebar ? true : this.showSidebar
      return {
        'sidebar-visible': visible,
        'sidebar-invisible': !visible,
      }
    },
    setHideToggle() {
      this.hideToggle = this.fixSidebar = window.matchMedia('(min-width: 1250px)').matches
      this.showSidebar = this.fixSidebar
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
  },
  computed: {
    sidebarWidth() {
      return this.fixSidebar ? '20vw' : '320px'
    },
  },
  data() {
    return {
      hideToggle: true,
      fixSidebar: true,
      showSidebar: true,
      menu: [
        {
          title: '온실가스',
          child: [
            // 모니터링
            {
              title: '모니터링',
              child: [
                {
                  title: '온실가스 배출',
                  child: [
                    {
                      title: '배출량',
                      href: '/esg/ghg-emission-amount-management',
                      child: [
                        {
                          title: '조직별',
                          href: '/esg/ghg-emission-amount-management-by-organization'
                        },
                        {
                          title: 'Scope별',
                          href: '/esg/ghg-emission-amount-management-by-scope'
                        },
                        {
                          title: '목표 대비',
                          href: '/esg/ghg-firmwide-goal-monitoring'
                        },
                      ]
                    },
                    {
                      title: '제품 생애주기 배출량',
                      href: '/esg/lca-emission-amount-management',
                      child: [
                        {
                          title: '제품별',
                          href: '/esg/lca-emission-amount-management-by-product'
                        },
                        {
                          title: '공정별',
                          href: '/esg/lca-emission-amount-management-by-process'
                        },
                      ]
                    }
                  ],
                },
                {
                  title: '탄소 중립비용',
                  child: [
                    {
                      title: 'Capex, Opex',
                      href: '/esg/carbon-neutral-cost'
                    },
                    {
                      title: '배출권 구매 비용',
                      href: '/esg/carbon-emission-expected-purchase-cost'
                    },
                  ],
                },
                {
                  title: '협력사',
                  href: '/esg/partner-corp-monitoring',
                  child: [
                    {
                      title: '탄소 감축 목표',
                      href: '/esg/partner-corp-monitoring-goal-management'
                    },
                    {
                      title: '자료 제출',
                      href: '/esg/partner-corp-monitoring-progress-management'
                    },
                    {
                      title: '공급망 평가',
                      href: '/esg/partner-corp-monitoring-assessment-management'
                    },
                    {
                      title: '배출량',
                      href: '/esg/partner-corp-monitoring-emission-amount-management'
                    },
                    {
                      title: '협력사 정보',
                      href: '/esg/partner-corp-monitoring-by-corp'
                    }
                  ]
                },
              ]
            },
            // /모니터링
            // 데이터 입력/조회
            {
              title: '데이터 입력/조회',
              child: [
                {
                  title: 'LCA Process',
                  child: [
                    {
                      title: '생산 데이터',
                      href: '/esg/tables/lca-production'
                    },
                    {
                      title: '투입 원료 데이터',
                      href: '/esg/tables/lca-material-input'
                    },
                    {
                      title: '업스트림 운송 데이터',
                      href: '/esg/tables/lca-upstream-transportation'
                    },
                    {
                      title: '공정 에너지 데이터',
                      href: '/esg/tables/lca-energy-input'
                    },
                    {
                      title: '공정 배출 폐기물 데이터',
                      href: '/esg/tables/lca-manufacturing-waste'
                    },
                    {
                      title: '다운스트림 운송 데이터',
                      href: '/esg/tables/lca-downstream-transportation'
                    },
                    {
                      title: '폐기 데이터',
                      href: '/esg/tables/lca-product-disposal'
                    },
                  ]
                },
                {
                  title: 'Scope 3 카테고리별 원자료',
                  child: [
                    {
                      title: 'Category 1 - 구매한 제품 및 서비스',
                      href: '/esg/tables/category1-purchased-goods'
                    },
                    {
                      title: 'Category 2 - 자본재(투자 및 구매)',
                      href: '/esg/tables/category2-capital-goods'
                    },
                    {
                      title: 'Category 3 - Scope 1, 2가 아닌 에너지 활동',
                      href: '/esg/tables/category3-energy-related-activity'
                    },
                    {
                      title: 'Category 4 - 업스트림 운송',
                      href: '/esg/tables/category4-upstream-transportation'
                    },
                    {
                      title: 'Category 5 - 공정 배출 폐기물',
                      href: '/esg/tables/category5-manufacturing-waste'
                    },
                    {
                      title: 'Category 6 - 임직원 출장',
                      href: '/esg/tables/category6-business-trip'
                    },
                    {
                      title: 'Category 7 - 임직원 출퇴근',
                      href: '/esg/tables/category7-commute'
                    }
                  ]
                },
                {
                  title: '사업장별 에너지 사용량 데이터',
                  href: '/esg/tables/energy-consumption'
                },
              ]
            },
            // /데이터 입력/조회
            // 기준정보관리
            {
              title: '기준정보관리',
              child: [
                {
                  title: '법인정보 관리',
                  href: '/esg/tables/corporation',
                },
                {
                  title: '사업장정보 관리',
                  href: '/esg/tables/business-location',
                },
                {
                  title: '시설정보 관리',
                  href: '/esg/tables/facility',
                },
                {
                  title: '생산제품 관리',
                  href: '/esg/tables/product'
                },
                {
                  title: 'LCA Process & Scope 구분',
                  href: '/esg/tables/lca-process'
                },
                {
                  title: '배출활동 관리',
                  href: '/esg/tables/emission-activity'
                },
                {
                  title: '연료 등 Scope 1, 2 배출계수',
                  href: '/esg/tables/emission-factor-energy'
                },
                {
                  title: '원재료 생산 등 Scope 3 배출계수',
                  href: '/esg/tables/emission-factor-non-energy'
                },
                {
                  title: '운송 관련 정보 관리',
                  child: [
                    {
                      title: '운송 배출계수',
                      href: '/esg/tables/emission-factor-transportation'
                    },
                    {
                      title: '공항 기준정보',
                      href: '/esg/tables/airport',
                    },
                    {
                      title: '공항 운항거리',
                      href: '/esg/tables/airport-distance'
                    },
                    {
                      title: '파트너정보 관리',
                      href: '/esg/tables/partner'
                    },
                    {
                      title: '기준거리 관리',
                      href: '/esg/tables/distance'
                    }
                  ]
                },
                {
                  title: '탄소/에너지원별 가격',
                  href: '/esg/tables/carbon-energy-price'
                },
              ]
            },
            // /기준정보관리
            {
              href: '/esg/data-io',
              title: '데이터 업로드 / 다운로드',
            },
          ]
        },

        // 공시보고서 메뉴
        {
          title: 'ESG 공시',
          child: [
            {
              title: '보고서 목차 생성',
              href: '/esg/disclosure-templates',
            },
            {
              title: '보고서 관리',
              href: '/esg/disclosures',
            },
            {
              title: '보고서 작성',
              href: '/esg/report/contents'
            }            
          ]
        },
        // /공시보고서 메뉴

        // 관리자 메뉴
        {
          title: '관리자 메뉴',
          child: [
            {
              title: '공통코드 관리',
              href: '/esg/tables/common-code',
            },
            {
              title: '온실가스 배출량 계산',
              href: '/esg/pcf-calculation'
            },
          ]
        }
      ]
    }
  },
}
</script>

<style scoped>
.toggle-top {
  display: block;
  align-self: center;
  width: 30px;
  height: 30px;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M15 33.3337L15 6.66699" stroke="%232E2E38" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M33.3327 31.667V8.33366C33.3327 7.41319 32.5865 6.66699 31.666 6.66699L8.33268 6.66699C7.41221 6.66699 6.66602 7.41318 6.66602 8.33366L6.66602 31.667C6.66602 32.5875 7.41221 33.3337 8.33268 33.3337H31.666C32.5865 33.3337 33.3327 32.5875 33.3327 31.667Z" stroke="%232E2E38" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/><rect width="17" height="26" transform="matrix(-1 0 0 1 33 7)" fill="%232E2E38"/></svg>');
  position: fixed;
  z-index: 1000;
}

.toggle-side {
  display: block;
  width: 30px;
  height: 30px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M15 33.3337L15 6.66699" stroke="%23C0C0C3" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M33.3327 31.667V8.33366C33.3327 7.41319 32.5865 6.66699 31.666 6.66699L8.33268 6.66699C7.41221 6.66699 6.66602 7.41318 6.66602 8.33366L6.66602 31.667C6.66602 32.5875 7.41221 33.3337 8.33268 33.3337H31.666C32.5865 33.3337 33.3327 32.5875 33.3327 31.667Z" stroke="%23C0C0C3" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/><rect width="8" height="26" transform="matrix(-1 0 0 1 15 7)" fill="%23C0C0C3"/></svg>');
  background-size: cover;
  background-repeat: no-repeat;
  margin-left: 2rem;
  margin-bottom: 5px;
  align-self: end;
  z-index: 1000;
}

>>> .b-sidebar-header {
  padding: 0;
  font-size: 1.5rem;
  display: flex;
  gap: 0 0;
  justify-content: center;
  align-items: center;
}

.ey-logo {
  height: 83px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.ey-logo-text {
  color: #FFF;
  font-size: 1.8rem;
  display: inline-block;
  line-height: 2.4rem;
  margin-top: 1.4rem;
}

.ey-logo-img {
  height: 3rem;
}

>>> .v-sidebar-menu {
  position: relative;
  background-color: #2E2E38;
  padding: 0 .75rem 0;
}

>>> .v-sidebar-menu .vsm--list {
  display: flex;
  flex-direction: column;
  gap: 0.8rem 0;
}

>>> .v-sidebar-menu .vsm--link {
  padding: 14px 16px;
  border-radius: 8px;
}

>>> .v-sidebar-menu .vsm--link_hover,
>>> .v-sidebar-menu .vsm--link:hover {
  background: rgba(255, 255, 255, 0.10);
}

>>> .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
>>> .v-sidebar-menu .vsm--link_level-1.vsm--link_active {
  box-shadow: none;
  background: rgba(255, 255, 255, 0.10);
}

>>> .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
  color: #FFE600;
  background: rgba(255, 255, 255, 0.10);
  border-radius: 8px 8px 0 0;
}

>>> .v-sidebar-menu .vsm--title {
  width: calc(100% - (20px + 0.833vw));
  color: rgba(255, 255, 255, 0.70);
  font-family: NanumGothic, serif;
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>> .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active .vsm--title,
>>> .v-sidebar-menu .vsm--link_level-1.vsm--link_active .vsm--title,
>>> .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--title {
  color: #FFE600;
}

>>> .v-sidebar-menu .vsm--dropdown > .vsm--list {
  position: relative;
  gap: 0.533rem 0;
  padding: 0 0 0.933rem 1.641vw;
  /* background: rgba(255, 255, 255, 0.10); */
  background-color: #43434C;
  border-radius: 0 0 8px 8px;
}

>>> .v-sidebar-menu .vsm--dropdown > .vsm--list::after {
  content: '';
  display: block;
  position: absolute;
  width: 1px;
  height: calc(100% - 0.933rem);
  border-radius: 30px;
  background-color: #747480;
}

>>> .v-sidebar-menu .vsm--dropdown .vsm--title {
  font-size: 16px;
  font-weight: 500;
}

>>> .v-sidebar-menu .vsm--dropdown .vsm--link {
  padding: 0.666rem;
  margin: 0 0.533rem;
}

>>> .v-sidebar-menu .vsm--arrow {
  width: 20px;
  height: 20px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.833 7.5L9.99967 13.3333L4.16634 7.5" stroke="%23C0C0C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

>>> .v-sidebar-menu .vsm--arrow::after {
  content: none;
}

>>> .v-sidebar-menu .vsm--arrow_open {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 12.5L10.0007 6.66667L4.16732 12.5" stroke="%23FFE600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  transform: none;
}

.sidebar-visible >>> .b-sidebar {
  display: flex !important
}

.sidebar-visible >>> .b-sidebar > .b-sidebar-body::-webkit-scrollbar {
  display: none;
}

.sidebar-visible >>> .b-sidebar > .b-sidebar-header {
  background-color: #2E2E38;
  color: lightgray;
}

.sidebar-visible >>> .b-sidebar > .b-sidebar-body {
  background-color: #2E2E38;
}

@media (max-width: 1250px) {
  .sidebar-invisible >>> .b-sidebar {
    display: none !important
  }
}
</style>